import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { isFilterExist } from '#component/general/list-filter/helper';

const useWithoutListData = ({ data, filterName, status, setWithoutData }) => {
  const listFilter = useSelector(s => s.listFilter, shallowEqual);
  const { applied } = listFilter;
  const filter = listFilter[filterName];

  useEffect(() => {
    const dataLoading = status !== 'succeeded' || status === 'idle';

    if (!dataLoading) {
      const filterExist = isFilterExist(filter ?? {});

      if (!filterExist && data.length === 0 && applied) {
        setWithoutData(true);
      } else if (filterExist && data.length === 0 && applied) {
        setWithoutData(false);
      }
    }
  }, [status, filterName, data.length, setWithoutData, filter, applied]);
};

export default useWithoutListData;
